// Felles ikoner, ett strøk (1.75) og én stil. Ingen unicode-tegn som ikoner.
const stroke = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
} as const;

// Iskra = gnist. Brukes som avatar (ikke logoen — den gjenskapes aldri i kode).
export const SPARK = (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M10 2.5 11.7 8.3 17.5 10 11.7 11.7 10 17.5 8.3 11.7 2.5 10 8.3 8.3Z" />
    <path d="M18 14.5 18.8 17.2 21.5 18 18.8 18.8 18 21.5 17.2 18.8 14.5 18 17.2 17.2Z" />
  </svg>
);

export const CHAT = (
  <svg class="ic-tab-icon" {...stroke}>
    <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H9l-5 4z" />
    <path d="M8.5 9h7M8.5 12h4.5" />
  </svg>
);

export const CLOSE = (
  <svg {...stroke}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const SEND = (
  <svg {...stroke} stroke-width="2">
    <path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" />
  </svg>
);

export const CALENDAR = (
  <svg {...stroke}>
    <rect x="3.5" y="5" width="17" height="15" rx="1.5" />
    <path d="M3.5 10h17M8 3v4M16 3v4" />
  </svg>
);

export const MAIL = (
  <svg {...stroke}>
    <rect x="3" y="5" width="18" height="14" rx="1.5" />
    <path d="m3.5 6.5 8.5 6.5 8.5-6.5" />
  </svg>
);

export const PERSON = (
  <svg {...stroke} stroke-width="2">
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20.5c1-3.7 4-5.5 7.5-5.5s6.5 1.8 7.5 5.5" />
  </svg>
);

export const BACK = (
  <svg {...stroke}>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

export const CHECK = (
  <svg {...stroke} stroke-width="2.25">
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </svg>
);
